import script from "./CardPortrait.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardPortrait.vue?vue&type=script&setup=true&lang=ts"

import "./CardPortrait.vue?vue&type=style&index=0&id=6a3ce4fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a3ce4fc"]])

export default __exports__